import axios from "axios";
import dotEnv from "dotenv";
dotEnv.config();

const apiURL = process.env.REACT_APP_BASE_URL;

const transactionemail = (offerId, accessToken, params = {}) => { 
  return axios.get(`${apiURL}/needToKnowEmailIdLogs/${offerId}`, {
    params,
    headers: {
      accept: "application/json",
      authorization: `bearer ${accessToken}`,
    },
  });
};

const gettitlecompany=(accessTokan)=>{
  // const accessTokan = localStorage.getItem("userAuth");
  return axios.get(`${apiURL}/titleOffice?titleType=TITLE_COMPANY&includeLimitedData=true`,{
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessTokan}`,
  },
  })
}
const getTitleoffice=(id,accessTokan)=>{
 
  return axios.get(`${apiURL}/titleOffice?titleType=TITLE_OFFICE&parentId=${id}`,{
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessTokan}`,
  },
  })
}

const searchTitleoffice=(id,val,accessTokan)=>{

  if(val.length>0)
  {
  return axios.get(`${apiURL}/titleOffice?titleType=TITLE_OFFICE&parentId=${id}&search=${val}`,{
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessTokan}`,
  },
  })
}else{
  return axios.get(`${apiURL}/titleOffice?titleType=TITLE_OFFICE&parentId=${id}`,{
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessTokan}`,
  },
  })
}
}

const addTitleoffice = (data,accessTokan, rootDocData, source) => {

  if (source === "TITLE_SIGNER_LIST") {
    return axios.post(`${apiURL}/updateTitleOrderForm`,
      {
        ...data,
      },
      {
        headers: {
          accept: "application/json",
          authorization: `bearer ${accessTokan}`,
        },
      });
  }
  return axios.post(`${apiURL}/updateTitleOrderForm?offerId=${data?.offerId}&titleOfficeId=${data?.titleOfficeId}`, 
  {
offerId:data?.offerId,
imageUrl: data?.imageUrl,
titleOfficeId:data?.titleOfficeId,
salesReps:data?.salesReps,
 salesRepsId :data?.titleRepId,
 titleClosuresId:data?.titleCloserId,
titleClosures:data?.titleClosures,
selectedBy: rootDocData?.openFor
  },
   {
    headers: {
      accept: "application/json",
      authorization: `bearer ${accessTokan}`,
    },
  });
};

const editOfficeImage = (data, contractAuthKey) => {
  const formData = new FormData();
  formData.append('fileBase64', data?.file?.originFileObj);
  formData.append("folderOf", "CLIENT_DOCUMENTS_PDF");
  return axios.post(`${apiURL}/common/uploadFile`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      accept: "application/json",
      authorization: `bearer ${contractAuthKey}`,
    },
  });
}

const getSharedDocsRequest = (offerId, accessToken, openFor) => {
  return axios.get(`${apiURL}/getSharedDocs`,{
    params: {
      offerId,
      openFor
    },
    headers: {
      accept: "application/json",
      authorization: `bearer ${accessToken}`,
    }
  })
}

const getEmailLogsRequest = ({ accessToken, queryData, sourceAxios }) => {
  const params = new URLSearchParams();

  if (queryData?.offerId) params.append("offerId", queryData.offerId);
  if (queryData?.propertyId) params.append("propertyId", queryData.propertyId);
  if (queryData?.senderPersonId) params.append("senderPersonId", queryData.senderPersonId);
  if (queryData?.transactionId) params.append("transactionId", queryData.transactionId);
  if (queryData?.emailType) params.append("type", queryData.emailType);
  if (queryData?.receiverPersonId) params.append("receiverPersonId", queryData.receiverPersonId);
  if (queryData?.openFor) params.append("openFor", queryData.openFor);
  if (queryData?.sectionFor) params.append("sectionFor", queryData.sectionFor);
  if (queryData?.sentBy) params.append("sentBy", queryData.sentBy);
  if (queryData?.fetchType) params.append("fetchType", queryData.fetchType);
  if (queryData?.logId) params.append("logId", queryData.logId);
  if (queryData?.viewFrom) params.append("viewFrom", queryData.viewFrom);

  return axios.get(`${apiURL}/getEmailLogs?${params.toString()}`, {
    headers: {
      accept: "application/json",
      authorization: `bearer ${accessToken}`,
    },
    cancelToken: sourceAxios?.token,
  });
};

export const closingApi = {
  transactionemail,
  addTitleoffice,
  searchTitleoffice,
  getTitleoffice,
  gettitlecompany,
  editOfficeImage,
  getSharedDocsRequest,
  getEmailLogsRequest,
};
